/** @jsx jsx */
import { jsx } from '@emotion/core';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { SvgIconProps } from '@material-ui/core';

/* Set tab index to 0 which makes the icon focusable on safari. 
 The value 0 defines the focus navigation order by the order in the document source (i.e sequential). */
const FocusableHelpOutlineIcon = (props: SvgIconProps): JSX.Element => {
  return <HelpOutlineIcon tabIndex={0} {...props} />;
};

export default FocusableHelpOutlineIcon;
